export default __webpack_public_path__ + "static/media/carousel-img-2.bc3703df.png";